import I18n from 'I18n';
import styled, { css } from 'styled-components';
import SVGKnowledgeBase from 'visitor-ui-component-library-icons/icons/SVGKnowledgeBase';
import SVGWebsite from 'visitor-ui-component-library-icons/icons/SVGWebsite';
import { useWidgetModalOrContext } from '../widget-modal/WidgetModalContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HEADER_BACKGROUND_COLOR = '#f0f0f0';
const TEXT_COLOR = '#141414';
const CitationHeaderWrapper = styled.div.withConfig({
  displayName: "CitationModalContent__CitationHeaderWrapper",
  componentId: "sc-15krtr4-0"
})(["flex:1;background-color:", ";padding:16px 0 16px 16px;color:", ";font-size:12px;"], HEADER_BACKGROUND_COLOR, TEXT_COLOR);
const ContentSourceType = styled.div.withConfig({
  displayName: "CitationModalContent__ContentSourceType",
  componentId: "sc-15krtr4-1"
})(["display:flex;align-items:center;margin-bottom:4px;"]);
const iconBaseStyles = css(["fill:", ";font-size:16px;margin-right:4px;"], TEXT_COLOR);
const WebsiteIcon = styled(SVGWebsite).withConfig({
  displayName: "CitationModalContent__WebsiteIcon",
  componentId: "sc-15krtr4-2"
})(["", ""], iconBaseStyles);
const KnowledgeBaseIcon = styled(SVGKnowledgeBase).withConfig({
  displayName: "CitationModalContent__KnowledgeBaseIcon",
  componentId: "sc-15krtr4-3"
})(["", ""], iconBaseStyles);
const citationLinkBaseStyles = css(["color:inherit;text-decoration:none;font-size:12px;line-height:18px;font-weight:600;&:hover{text-decoration:underline;}"]);
const CitationLink = styled.a.withConfig({
  displayName: "CitationModalContent__CitationLink",
  componentId: "sc-15krtr4-4"
})(["", ""], citationLinkBaseStyles);
const CitationButton = styled.button.withConfig({
  displayName: "CitationModalContent__CitationButton",
  componentId: "sc-15krtr4-5"
})(["", " border:none;padding:0;background-color:transparent;cursor:pointer;"], citationLinkBaseStyles);
const CitationButtonAsLink = ({
  children,
  source,
  browserWindowHeight,
  navigateToKnowledgeBaseArticle
}) => {
  const {
    closeModal
  } = useWidgetModalOrContext();
  const handleClick = () => {
    navigateToKnowledgeBaseArticle({
      deepLink: source.deepLink,
      hubSpotContentId: source.hubSpotContentId,
      hubSpotContentTextFragment: source.hubSpotContentTextFragment
    }, browserWindowHeight);
    closeModal();
  };
  return /*#__PURE__*/_jsx(CitationButton, {
    onClick: handleClick,
    children: children || I18n.text('conversations-visitor-message-history.viewSource')
  });
};
CitationButtonAsLink.displayName = 'CitationButtonAsLink';
const CitationHeader = ({
  browserWindowHeight,
  navigateToKnowledgeBaseArticle,
  source
}) => {
  const {
    deepLink,
    hubSpotContentType,
    title,
    url
  } = source;
  const isKbArticle = hubSpotContentType === 'KB_ARTICLE';
  const icon = isKbArticle ? /*#__PURE__*/_jsx(KnowledgeBaseIcon, {}) : /*#__PURE__*/_jsx(WebsiteIcon, {});
  const text = isKbArticle ? I18n.text('conversations-visitor-message-history.knowledgeBase') : I18n.text('conversations-visitor-message-history.website.singular');
  const link = isKbArticle && navigateToKnowledgeBaseArticle ? /*#__PURE__*/_jsx(CitationButtonAsLink, {
    source: source,
    browserWindowHeight: browserWindowHeight,
    navigateToKnowledgeBaseArticle: navigateToKnowledgeBaseArticle,
    children: title
  }) : /*#__PURE__*/_jsx(CitationLink, {
    href: deepLink,
    target: "_blank",
    rel: "noopener noreferrer",
    children: url
  });
  return /*#__PURE__*/_jsxs(CitationHeaderWrapper, {
    children: [/*#__PURE__*/_jsxs(ContentSourceType, {
      children: [icon, /*#__PURE__*/_jsx("p", {
        children: text
      })]
    }), link]
  });
};
CitationHeader.displayName = 'CitationHeader';
export const CitationModalContent = (source, browserWindowHeight, navigateToKnowledgeBaseArticle) => {
  return {
    headerContent: /*#__PURE__*/_jsx(CitationHeader, {
      browserWindowHeight: browserWindowHeight,
      navigateToKnowledgeBaseArticle: navigateToKnowledgeBaseArticle,
      source: source
    }),
    bodyContent: null,
    colorOverrides: {
      headerBackgroundColor: HEADER_BACKGROUND_COLOR
    }
  };
};
CitationModalContent.displayName = 'CitationModalContent';